import { ReportHistoryContainer } from './reportHistoryContainer';
import { useTranslation } from 'react-i18next';
import { HistoryCategory } from './historyCategory';
import {
  comparisonParameterHistoryData,
  GraphTypes,
  useReportsStore,
} from '../stores';
import { observer } from 'mobx-react-lite';
import { Parameters } from '@web/common';

export const HeartHealthReportHistory = observer(() => {
  const { t } = useTranslation(['common', 'reports', 'infoTexts']);
  const reportsStore = useReportsStore();

  return (
    <ReportHistoryContainer>
      <HistoryCategory
        parameters={[
          {
            type: GraphTypes.COMPARISON,
            parameter: Parameters.BLOOD_PRESSURE,
            unit: 'mmHg',
            data: reportsStore.getComparisonParameterValues(
              Parameters.BLOOD_PRESSURE_SYSTOLIC,
              Parameters.BLOOD_PRESSURE_DIASTOLIC,
            ) as comparisonParameterHistoryData[],
            infoText: t('infoTexts:blood_pressure_info'),
          },
          {
            type: GraphTypes.VALUE,
            parameter: Parameters.PULSE,
            unit: reportsStore.getParameterUnit(Parameters.PULSE),
            data: reportsStore.getValueParameterValues(Parameters.PULSE),
            infoText: t('infoTexts:pulse_info'),
          },
          {
            type: GraphTypes.CATEGORY,
            parameter: Parameters.CARDIO_FITNESS,
            unit: '',
            data: reportsStore.getCategoryParameterValues(
              Parameters.CARDIO_FITNESS,
            ),
            thresholds: reportsStore.getParameterThresholds(
              Parameters.CARDIO_FITNESS,
            ),
            infoText: t('infoTexts:cardio_fitness_info'),
          },
          {
            type: GraphTypes.CATEGORY,
            parameter: Parameters.HEART_STRENGTH,
            unit: '',
            data: reportsStore.getCategoryParameterValues(
              Parameters.HEART_STRENGTH,
            ),
            thresholds: reportsStore.getParameterThresholds(
              Parameters.HEART_STRENGTH,
            ),
            infoText: t('infoTexts:heart_strength_info'),
          },
        ]}
        maxWidth={1000}
      />
    </ReportHistoryContainer>
  );
});
